import { EmbryoService } from './../../../Services/Embryo.service';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-size-charts-dialog',
  templateUrl: './size-charts-dialog.component.html',
  styleUrls: ['./size-charts-dialog.component.css'],
})
export class SizeChartsDialogComponent {
  acceptFileTypes: RegExp = /^application\/(pdf|msword)$|^text\/plain$/i;
  isTypePdf: boolean = false;
  lang: string = '';
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private embryoService: EmbryoService
  ) {
    this.embryoService.emitLang.subscribe((lang: any) => {
      this.lang = lang;
      this.isTypePdf =
        lang == 'en' ? this.checkUrlType(data.en) : this.checkUrlType(data.ar);
    });
  }
  checkUrlType(value: string): boolean {
    return value?.substring(value.length - 3, value.length) === 'pdf';
  }
}
